<template>
  <router-link
    :to="{ path: `/${routeName}/${brand_id}/${store_id}/${orderId}` }"
    :class="className"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5V1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15V15Z"
        fill="white"
      ></path>
      <path
        d="M9 6.75C9.41421 6.75 9.75 6.41421 9.75 6C9.75 5.58579 9.41421 5.25 9 5.25C8.58579 5.25 8.25 5.58579 8.25 6C8.25 6.41421 8.58579 6.75 9 6.75Z"
        fill="white"
      ></path>
      <path
        d="M9 7.5C8.80109 7.5 8.61032 7.57902 8.46967 7.71967C8.32902 7.86032 8.25 8.05109 8.25 8.25V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V8.25C9.75 8.05109 9.67098 7.86032 9.53033 7.71967C9.38968 7.57902 9.19891 7.5 9 7.5Z"
        fill="white"
      ></path>
    </svg>
    {{ _T('Detail') }}
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ButtonOrderDetails',
  props: ['className', 'orderId', 'routeName', 'brandId', 'storeId'],
  computed: {
    ...mapGetters(['_T', 'brandWiseStores', 'all_stores', 'all_brands', 'set_website_slug']),
    store_id() {
      if (this.storeId) {
        let store = this.all_stores.find(store => store._id === this.storeId)
        if (store) return this.set_website_slug(store)
      } return this.storeId
    },
    brand_id() {
      if (this.brandId) {
        let brand = this.all_brands.find(brand => brand._id === this.brandId)
        if (brand) return this.set_website_slug(brand)
      } return this.brandId
    }
  },
}
</script>

<style lang="scss" scoped></style>
